import {RouterStateSnapshot, ActivatedRouteSnapshot,  Router,   CanActivate} from '@angular/router';
import { Injectable } from '@angular/core';
import { SharedService } from '../shared.service';

@Injectable()
export class PremiumUser implements CanActivate {

  premium: boolean;

  constructor(public router: Router,
              private sharedService: SharedService
  ) {
    this.sharedService.getUserType().subscribe( userType => {
      if (userType === 'simpleTravel') {
        this.premium = true;
      }else {
        this.premium = false;
      }
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.premium === true) {
      return true;
    }

      this.router.navigate(['']);
      return false;

  }
}



// WEBPACK FOOTER //
// ./src/app/core/premiumUser.guard.ts